<template>
	<div class="device-account">
		<gc-header header-data="gatewayDevice"></gc-header>
		<div class="content">
			<div class="right">
				<div class="filter">
					<gc-advanced-filter
						ref="advancedFilter"
						v-model="params"
						:fields="filterFields"
						@search="handleFilterSearch"
						@reset="handleFilterReset"
					/>
					<gc-column-setting
						:storageKey="`localcolumn-gateway-device`"
						:columns="columns"
						@update-column="data => (columns = data)"
					></gc-column-setting>
				</div>
				<div class="table" v-loading="loading">
					<gc-table
						border
						showPage
						:total="pagination.total"
						:columns="columnList"
						:table-data="tableData"
						:current-page.sync="pagination.currentPage"
						:page-size="pagination.pageSize"
						@current-page-change="handleCurrentPageChange"
						@size-change="handlePageSizeChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetDeviceTypeList, apiGetGatewayDevicePageList } from '@/apis/account.api'
import { nameTrans } from '@/utils'
import { isBlank } from '@/utils/validate'
export default {
	data() {
		return {
			searchOptions: {
				userType: [],
				deviceTypeId: [],
				deviceStatus: [],
				installLocation: [],
			},
			params: {
				deviceNo: null,
				userName: null,
				address: null,
				deviceTypeIdList: [],
				useType: null,
				installLocationList: null,
				deviceStatus: null,
				installDate: [],
				isOnline: null,
			},
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
					fixed: 'left',
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'subDeviceNum',
					name: '子设备数量',
				},
				{
					key: 'deviceTypeName',
					name: '设备类型名称',
					tooltip: true,
				},
				{
					key: 'roomName',
					name: '房间名称',
					tooltip: true,
				},
				{
					key: 'username',
					name: '客户名称',
					tooltip: true,
				},
				{
					key: 'addressName',
					name: '安装地址',
					tooltip: true,
					minWidth: 200,
				},
				{
					key: 'installDate',
					name: '安装日期',
					width: 180,
				},
				{
					key: 'manufacturerName',
					name: '设备厂商',
					tooltip: true,
				},
				{
					key: 'deviceStatusName',
					name: '设备状态',
					render: (h, row) => {
						let val = row.deviceStatus
						let statusMap = {
							0: { class: 'dot-error', text: '待安装' },
							1: { class: 'dot-success', text: '已安装' },
							2: { class: 'dot-message', text: '已拆除' },
						}
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{
					key: 'isOnline',
					name: '是否在线',
					minWidth: 100,
					render: (h, row) => {
						return h(
							'span',
							{},
							isBlank(row.isOnline) ? '--' : nameTrans(row.isOnline, this.isOnlineOptions),
						)
					},
				},
				{
					key: 'isAlarm',
					name: '是否告警',
					minWidth: 100,
					render: (h, row) => {
						return h(
							'span',
							{
								style: {
									color: !isBlank(row.isAlarm) && row.isAlarm == 0 ? '#E5662E' : '#4e4e4e',
								},
							},
							isBlank(row.isAlarm) ? '--' : nameTrans(row.isAlarm, this.isAlarmOptions),
						)
					},
				},
				{
					key: 'lastCommunicateTime',
					name: '最后通讯时间',
					minWidth: 160,
					sortable: 'custom',
				},
				{
					key: 'oprate',
					name: '操作',
					width: 150,
					fixed: 'right',
					render: (h, row) => {
						const style = {
							fontSize: '14px',
							color: '#4A69FF',
							marginRight: '12px',
							cursor: 'pointer',
						}
						return h('div', null, [
							...[
								this.$has('monitor:bkitchen:room:detail:select')
									? [
											h(
												'span',
												{
													style,
													on: {
														click: () => this.handleToDeviceDetails(row),
													},
												},
												'查看详情',
											),
									  ]
									: [],
							],
						])
					},
				},
			],
			exportParams: null,
		}
	},

	created() {
		this.queryDeviceTypeList()
		this.searchOptions.useType = this.$store.getters?.dataList?.useTypeGas || []
		this.searchOptions.deviceStatus = this.searchOptions.deviceStatus =
			this.$store.getters?.dataList?.deviceStatus || []
		this.queryTableDataPageList()
	},

	methods: {
		handleFilterSearch() {
			this.handleCurrentPageChange(1)
		},

		handleFilterReset() {
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		async queryTableDataPageList() {
			const params = this.getRequestParams()
			if (!params) return
			this.loading = true
			const searchParams = {
				...params,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetGatewayDevicePageList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryTableDataPageList()
		},

		getRequestParams() {
			const params = new Object()
			for (const key in this.params) {
				const value = this.params[key]
				if (!isBlank(value)) {
					if (key === 'installDate' && value.length) {
						params.installStartDate = this.dayjs(value[0]).format('YYYY-MM-DD')
						params.installEndDate = this.dayjs(value[1]).format('YYYY-MM-DD')
					} else {
						params[key] = value
					}
				}
			}
			if (params.address && params.address.length < 2) return this.$message.warning('安装地址不可以少于2个字符')
			this.exportParams = { ...params }
			return params
		},

		async handleToDeviceDetails(data) {
			this.$router.push({
				path: '/device/detail',
				query: {
					deviceId: data.deviceId,
					deviceType: data.deviceTypeId,
					gateway: 1,
					iotDeviceId: data.iotDeviceId,
				},
			})
		},

		async queryDeviceTypeList() {
			const data = await apiGetDeviceTypeList({
				tenantId: this.tenantId,
				deviceTypeClassify: '5',
			})
			this.searchOptions.deviceTypeId = (data.records || []).map(item => {
				return {
					value: item.deviceTypeId,
					label: item.deviceTypeName,
				}
			})
		},
	},

	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},

		filterFields() {
			return [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'userName',
					label: '客户名称',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'address',
					label: '安装地址',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeId,
						filterable: true,
						multiple: true,
						needAllForSearch: true,
					},
				},
				{
					prop: 'deviceStatus',
					label: '设备状态',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceStatus,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'useType',
					label: '使用类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.useType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'installLocationList',
					label: '安装位置',
					type: 'select',
					props: {
						searchOption: this.searchOptions.installLocation,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
						multiple: true,
						tip: '请先选择使用类型后再选择安装位置',
					},
				},
				{
					prop: 'isOnline',
					label: '是否在线',
					type: 'select',
					props: {
						searchOption: this.$store.getters.dataList.isOnline,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'installDate',
					label: '安装日期',
					type: 'date',
					props: {
						datePickerType: 'daterange',
					},
				},
			]
		},

		isOnlineOptions() {
			return this.$store.getters.dataList.isOnline || []
		},
		isAlarmOptions() {
			return this.$store.getters.dataList.isAlarm || []
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},
	},

	watch: {
		'params.useType'(newVal) {
			if (newVal) {
				this.searchOptions.installLocation = (this.$store.getters?.dataList?.installLocationGas || []).filter(
					m => m.defaultValue[0] === newVal,
				)
			} else {
				this.searchOptions.installLocation = []
			}
			this.params.installLocationList = null
		},
	},
}
</script>
<style lang="scss" scoped>
.device-account {
	@include base-button(80px);
	height: 100%;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	.content {
		flex: 1;
		display: flex;
		padding: 0 12px;
		height: 0;
		.left {
			width: 300px;
			height: 100%;
			padding: 20px 8px 8px 0;
			border-right: 1px solid #f1f1f1;
			& + .right {
				padding-left: 20px;
			}
		}
		.right {
			flex: 1;
			width: 0;
			display: flex;
			height: 100%;
			flex-direction: column;
			.filter {
				display: flex;
				flex-wrap: wrap;
				padding: 12px 0;
			}
			.table {
				flex: 1;
				height: 0;
			}
		}
	}
}
</style>
